<template>

  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{_.startCase(currentProfile)}}
          </h3>
        </div>
        <div class="col-md-9 text-right">
        </div>
      </div>
    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
            <h6 class="heading-small text-muted mb-4">X-READING PREVIEW</h6>
            <!-- version 5.1 -->
          <div v-if="xread_data && xread_data.version !== undefined && xread_data.version == 5.1 && this.xread_data != null">
            <!-- <div v-if="this.xread_data != null" style="font-family: Palatino Linotype"> -->
                <!-- <center>
                        IRIPPLE STORE <br>
                        Operated By: IRIPPLE STORES INC. <br>
                        Ortigas Center, Pasig City <br>
                        VAT REG TIN: 123-456-789-00000 <br>
                        SN: 1234567890 MIN: 9876543210 <br>
                        Permit No. FP092019-25A-0010924-00000 <br>
                </center> -->
                <br>
                <!-- X Reading : {{this.xread_data.zReadingCounter}} <br> -->
                Terminal  : {{xread_data.terminal}} <br>
                Cashier  : {{xread_data.cashierName}} <br>
                Printed by  : {{xread_data.printedBy}} <br><br>
                Start Date & Time    : {{this.xread_data.dateFrom}} <br>
                End Date & Time    : {{this.xread_data.dateTo}} <br><br>

                <table width="100%">
                     <tr>
                        <td>BEGINNING TRANS #</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.firstTransactionId}}</td>
                    </tr>

                    <tr>
                        <td>ENDING TRANS #</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.lastTransactionId}}</td>
                    </tr>
                    <tr>
                        <td>TRANSACTION COUNT</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.totalTransactionCount}}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr>
                        <td>X COUNTER NO.</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.xReadingCounter}} </td>
                    </tr>
                    <tr>
                        <td colspan="3">----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>MANUAL/REPLACED SI</th>
                        <td align="right"> {{ xread_data.manualSales && xread_data.manualSales.manualCount != null ? xread_data.manualSales.manualCount : 0 }} </td>
                        <td align="right"> {{ xread_data.manualSales && xread_data.manualSales.manualTotal != null ? formatNumber(parseFloat(xread_data.manualSales.manualTotal).toFixed(2)): "0.00" }} </td>
                    </tr>
                    <tr>
                        <td colspan="3">----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>BREAKDOWN OF SALES</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VATABLE SALES</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.grossSales.vatable).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VAT AMOUNT</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.grossSales.vatAmount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VAT-EXEMPT SALES</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.grossSales.vatExempt).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">ZERO-RATED SALES</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.grossSales.zeroRated).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                     <tr>
                        <th>GROSS AMOUNT</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.grossSales.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>LESS DISCOUNT</th>
                        <td align="right"></td>
                        <td align="right">
                          {{formatNumber(parseFloat(this.xread_data.deductions.total - (parseFloat(this.xread_data.deductions.void) + this.xread_data.deductions.manual)).toFixed(2))}}
                        </td>
                    </tr>
                    <tr>
                        <th>LESS VOID</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.void).toFixed(2))}}</td>
                    </tr>
                     <tr>
                        <th>LESS VAT ADJUSTMENT</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.total - this.xread_data.adjustmentsOnVat.manual).toFixed(2))}}</td>
                    </tr>
                     <tr>
                        <th>NET AMOUNT</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.netSales).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>DISCOUNT SUMMARY</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SC 5% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.deductions && this.xread_data.deductions.senior5 ? formatNumber(parseFloat(this.xread_data.deductions.senior5).toFixed(2)) : "0.00" }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SC 20% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.deductions && this.xread_data.deductions.senior20 ? formatNumber(parseFloat(this.xread_data.deductions.senior20).toFixed(2)) : "0.00" }}</td>
                        <!-- <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.senior20).toFixed(2))}}</td> -->
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">PWD 5% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.deductions && this.xread_data.deductions.pwd5 ? formatNumber(parseFloat(this.xread_data.deductions.pwd5).toFixed(2)) : "0.00" }}</td>
                        <!-- <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.pwd5).toFixed(2))}}</td> -->
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">PWD 20% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.deductions && this.xread_data.deductions.pwd20 ? formatNumber(parseFloat(this.xread_data.deductions.pwd20).toFixed(2)) : "0.00" }}</td>
                        <!-- <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.pwd20).toFixed(2))}}</td> -->
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">NAAC DISC</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.deductions && this.xread_data.deductions.naac_total ? formatNumber(parseFloat(this.xread_data.deductions.naac_total).toFixed(2)) : "0.00" }}</td>
                        <!-- <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.naac_total).toFixed(2))}}</td> -->
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">MOV DISC</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.deductions && this.xread_data.deductions.mov_total ? formatNumber(parseFloat(this.xread_data.deductions.mov_total).toFixed(2)) : "0.00" }}</td>
                        <!-- <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.mov_total).toFixed(2))}}</td> -->
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">OTHER DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.regular).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>SALES ADJUSTMENT</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VOID</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.void).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>VAT ADJUSTMENT</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SC TRANS</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.adjustmentsOnVat && this.xread_data.adjustmentsOnVat.senior20 ? formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.senior20).toFixed(2)) : "0.00" }}</td>
                        <!-- <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.senior20 + this.xread_data.adjustmentsOnVat.senior5).toFixed(2))}}</td> -->
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">PWD TRANS</td>
                        <td align="right"></td>
                        <!-- <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.pwd20 + this.xread_data.adjustmentsOnVat.pwd5).toFixed(2))}}</td> -->
                        <td align="right">{{this.xread_data.adjustmentsOnVat && this.xread_data.adjustmentsOnVat.pwd20 ? formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.pwd20).toFixed(2)) : "0.00" }}</td>

                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">OTHER TRANS</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.regular).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VAT ON VOID</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.void).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>NET VAT BREAKDOWN</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VATABLE</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.netSalesBreakdown.vatable).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VAT AMOUNT PAYABLE</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.netSalesBreakdown.vatAmount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VAT-EXEMPT</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.netSalesBreakdown.vatExempt).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">ZERO-RATED</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.netSalesBreakdown.zeroRated).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>PAYMENT SUMMARY</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr>
                        <th>AMOUNT IN DRAWER</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.amountInDrawer.total).toFixed(2))}}</td>
                    </tr>
                    <!-- ADD PAYMENT BREAKDOWN HERE -->

                    <tr v-for="payment in paymentTypes" :key="payment.id">
                        <td style="padding-left: 5%;" v-if="!isNaN(parseFloat(xread_data.paymentSummary[payment.code])) && parseFloat(xread_data.paymentSummary[payment.code]) !== 0">{{payment.name}}</td>
                        <td align="right" v-if=" !isNaN(parseFloat(xread_data.paymentSummary[payment.code])) && parseFloat(xread_data.paymentSummary[payment.code]) !== 0">{{xread_data.paymentSummary[`${payment.code}Count`]}}</td>
                        <td align="right" v-if="!isNaN(parseFloat(xread_data.paymentSummary[payment.code])) && parseFloat(xread_data.paymentSummary[payment.code]) !== 0" >{{formatNumber(parseFloat(xread_data.paymentSummary[`${payment.code}`]).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>OPENING FUND</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.amountInDrawer.deposit).toFixed(2))}}</td>
                    </tr>
                    <tr>
                      <th>LESS WITHDRAWAL</th>
                      <td align="right"></td>
                      <td align="right">({{formatNumber(parseFloat(this.xread_data.amountInDrawer.withdrawal).toFixed(2))}})</td>
                    </tr>
                    <tr>
                        <th>PAYMENTS RECEIVED</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.amountInDrawer.payments).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>OTHER INCOME</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.otherIncome.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>EXCESS GC</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.otherIncome.excessGC).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>EXCESS RS</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.otherIncome.excessRS).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>SHORT/OVER</th>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.short_over ? formatNumber(parseFloat(this.xread_data.short_over).toFixed(2)) : "0.00" }}</td>
                        <!-- <td align="right">{{formatNumber(parseFloat(this.xread_data.short_over).toFixed(2))}}</td> -->
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>TRANSACTION TYPE SUMMARY</th>
                    </tr>
                    <tr v-for="transType in xread_data.transactionTypeList" :key="transType.tranTypeName">
                        <td style="padding-left: 5%;">{{transType.tranTypeName}}</td>
                        <td align="right" >{{transType.count}}</td>
                        <td align="right" >{{formatNumber(parseFloat(transType.total).toFixed(2))}}</td>
                    </tr>
                     <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>SERVICE FEE BEFORE TAX</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr
                      v-for="(item, index) in serviceChargeSummary"
                      :key="'svc-' + index"
                    >
                      <td style="padding-left: 5%;">{{ item.label }}</td>
                      <td align="right"></td>
                      <td align="right">
                        {{ formatNumber(item.amount.toFixed(2)) }}
                      </td>
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>COLLECTIONS</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">BEGINNING AR</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.reservation.beginningAr}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">ENDING AR</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.reservation.endingAr}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">AR COUNT</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.reservation.arCount}}</td>
                    </tr>
                    <tr>
                        <td colspan="3"></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">RESERVATION DP:</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.reservation.collections.paymentSummary.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">OTHER COLLECTIONS</td>
                        <td align="right"></td>
                        <td align="right">{{this.xread_data.otherCollectionAmount ? formatNumber(parseFloat(this.xread_data.otherCollectionAmount).toFixed(2)) : "0.00" }}</td>
                        <!-- <td align="right">{{formatNumber(parseFloat(this.xread_data.otherCollectionAmount).toFixed(2))}}</td> -->
                    </tr>
                    <tr>
                        <td colspan="3">---------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>TOTAL</th>
                        <td align="right"></td>
                        <!-- <td align="right"> {{ formatNumber(parseFloat(((xread_data?.reservation?.collections?.paymentSummary?.total ?? 0) + (xread_data?.otherManualCollections ?? 0)).toFixed(2))) }} </td> -->
                        <td align="right">
                        {{
                          formatNumber(
                            (
                              (
                                xread_data &&
                                xread_data.reservation &&
                                xread_data.reservation.collections &&
                                xread_data.reservation.collections.paymentSummary &&
                                xread_data.reservation.collections.paymentSummary.total
                              ? parseFloat(xread_data.reservation.collections.paymentSummary.total)
                              : 0
                              )
                              +
                              (
                                xread_data &&
                                xread_data.otherManualCollections
                              ? parseFloat(xread_data.otherManualCollections)
                              : 0
                              )
                            ).toFixed(2)
                          )
                        }}
                      </td>

                    </tr>
                      <tr>
                        <th>PAYMENT SUMMARY</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr v-for="(item, index) in reservationPaymentSummary" :key="index">
                      <td style="padding-left: 5%;">{{ item.name }}</td>
                      <td align="right" > {{ item.count }}</td>
                      <td align="right"> {{ formatNumber(item.amount.toFixed(2)) }} </td>
                    </tr>
                    <tr>
                        <th>COLLECTION SUMMARY</th>
                        <td align="right"></td>
                        <td align="right"></td>
                    </tr>
                    <tr
                      v-for="(item, index) in reservationOtherCollectionsSummary"
                      :key="'other-' + index"
                    >
                      <td style="padding-left: 5%;">{{ item.name }}</td>

                      <td align="center">
                        {{ item.count }}
                      </td>

                      <td align="right">
                        {{ formatNumber(item.amount.toFixed(2)) }}
                      </td>
                    </tr>
                </table>
            </div>
        
            <!-- version 5.0 -->
            <!-- <div v-if="this.xread_data != null" style="font-family: Palatino Linotype"> -->
             <div v-else-if="this.xread_data != null"> 
                <!-- <center>
                        IRIPPLE STORE <br>
                        Operated By: IRIPPLE STORES INC. <br>
                        Ortigas Center, Pasig City <br>
                        VAT REG TIN: 123-456-789-00000 <br>
                        SN: 1234567890 MIN: 9876543210 <br>
                        Permit No. FP092019-25A-0010924-00000 <br>
                </center> -->
                <br>
                <!-- X Reading # : {{this.xread_data.xReadingCounter}} <br> -->
                Terminal  : {{xread_data.terminal}} <br>
                Cashier  : {{xread_data.cashierName}} <br>
                Printed by  : {{xread_data.printedBy}} <br>
                Date    : {{this.xread_data.business_date}} <br><br>
                <table width="100%">
                    <tr>
                        <th>GROSS SALES</th>
                        <td align="right">{{this.xread_data.grossSales.count}}</td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.grossSales.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VATABLE SALES</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.grossSales.vatable).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VAT AMOUNT</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.grossSales.vatAmount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VAT-EXEMPT SALES</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.grossSales.vatExempt).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">ZERO-RATED SALES</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.grossSales.zeroRated).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>DEDUCTIONS</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">REG DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.regular).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SP 5% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.specialVatableDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SP 20% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.specialVatExemptDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">RETURNS</td>
                        <td align="right">{{this.xread_data.deductions.returnsCount}}</td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.returns).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VOID</td>
                        <td align="right">{{this.xread_data.deductions.voidCount}}</td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.void).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">MANUAL</td>
                        <td align="right">{{this.xread_data.deductions.manualCount}}</td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.deductions.manual).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>VAT ADJUSTMENTS</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">REG DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.regular).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SP 5% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.specialVatableDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">SP 20% DISC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.specialVatExemptDiscount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">RETURNS</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.returns).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">VOID</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.void).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">MANUAL</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.adjustmentsOnVat.manual).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td colspan="3">-----------------------------------------------------------------------------------------</td>
                    </tr>
                    <tr>
                        <th>NET SALES</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.netSales).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>NET VAT AMOUNT</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.netVatAmount).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>TOTAL QUANTITY</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.totalQuantity).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>OTHER INCOME</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.otherIncome.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">EXCESS GC</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.otherIncome.excessGC).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">EXCESS RS</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.otherIncome.excessRS).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <th>AMOUNT IN DRAWER</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.amountInDrawer.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">+ DEPOSIT</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.amountInDrawer.deposit).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">+ PAYMENTS</td>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.amountInDrawer.payments).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">- WITHDRAWAL</td>
                        <td align="right"></td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.amountInDrawer.withdrawal).toFixed(2))}})</td>
                    </tr>

                    <tr>
                        <th>PAYMENT SUMMARY</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.paymentSummary.total).toFixed(2))}}</td>
                    </tr>
                    <!-- ADD PAYMENT BREAKDOWN HERE -->

                    <tr v-for="payment in paymentTypes" :key="payment.id">
                        <td style="padding-left: 5%;" v-if="!isNaN(parseFloat(xread_data.paymentSummary[payment.code])) && parseFloat(xread_data.paymentSummary[payment.code]) !== 0">{{payment.name}}</td>
                        <td align="right" v-if=" !isNaN(parseFloat(xread_data.paymentSummary[payment.code])) && parseFloat(xread_data.paymentSummary[payment.code]) !== 0">{{xread_data.paymentSummary[`${payment.code}Count`]}}</td>
                        <!-- <td align="right" v-if="_.isNaN(parseFloat(xread_data.paymentSummary[`${payment.code}`]))" >0.00</td> -->
                        <td align="right" v-if="!isNaN(parseFloat(xread_data.paymentSummary[payment.code])) && parseFloat(xread_data.paymentSummary[payment.code]) !== 0">{{formatNumber(parseFloat(xread_data.paymentSummary[`${payment.code}`]).toFixed(2))}}</td>

                    </tr>

                    <tr>
                        <th>TRANSACTION TYPE SUMMARY</th>
                    </tr>
                    <tr v-for="transType in xread_data.transactionTypeList" :key="transType.tranTypeName">
                        <td style="padding-left: 5%;">{{transType.tranTypeName}}</td>
                        <td align="right" >{{transType.count}}</td>
                        <td align="right" >{{formatNumber(parseFloat(transType.total).toFixed(2))}}</td>
                    </tr>

                    <!-- <tr>
                        <th>PAYMENT SUMMARY</th>
                        <td align="right"></td>
                        <td align="right">{{formatNumber(parseFloat(this.xread_data.paymentSummary.total).toFixed(2))}}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">Cash</td>
                        <td align="right">{{this.xread_data.paymentSummary.cashCount}}</td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.paymentSummary.cash).toFixed(2))}})</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">Charge</td>
                        <td align="right">{{this.xread_data.paymentSummary.chargeCount}}</td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.paymentSummary.charge).toFixed(2))}})</td>
                    </tr>
                   
                    <tr>
                        <td style="padding-left: 5%;">Coupon</td>
                        <td align="right">{{this.xread_data.paymentSummary.couponCount}}</td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.paymentSummary.coupon).toFixed(2))}})</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">Credit Card</td>
                        <td align="right">{{this.xread_data.paymentSummary.creditCardCount}}</td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.paymentSummary.creditCard).toFixed(2))}})</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">Credit Memo</td>
                        <td align="right">{{this.xread_data.paymentSummary.creditMemoCount}}</td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.paymentSummary.creditMemo).toFixed(2))}})</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 10%;">RS Excess</td>
                        <td align="right">{{this.xread_data.paymentSummary.rsExcessCount}}</td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.paymentSummary.rsExcess).toFixed(2))}})</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">Debit Card</td>
                        <td align="right">{{this.xread_data.paymentSummary.debitCardCount}}</td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.paymentSummary.debitCard).toFixed(2))}})</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">Gift Certificate</td>
                        <td align="right">{{this.xread_data.paymentSummary.giftCertificateCount}}</td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.paymentSummary.giftCertificate).toFixed(2))}})</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 10%;">GC Excess</td>
                        <td align="right">{{this.xread_data.paymentSummary.gcExcessCount}}</td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.paymentSummary.gcExcess).toFixed(2))}})</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 5%;">Reward Point</td>
                        <td align="right">{{this.xread_data.paymentSummary.rewardPointCount}}</td>
                        <td align="right">({{formatNumber(parseFloat(this.xread_data.paymentSummary.rewardPoint).toFixed(2))}})</td>
                    </tr> -->
                </table>
            </div>
    </a-drawer>
   
    <div class="row align-items-right mr-2">
      <div class="col-md-12">
          <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div v-if="accessRights.includes('E')" class="dropdown-item"
               @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span> <br>
              </div>
            </template>
          </base-dropdown>
        </div>
    </div>

    <div class="table-responsive m-2" >
        <vuetable  ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
        @vuetable:load-error="onLoadError" 
        @vuetable:pagination-data="onPaginationData">

        <template slot="actions" slot-scope="props">
          <center>
            <button class="btn btn-success btn-sm" @click.prevent="showDetails(props.rowData.reading_details)">View Details</button>&nbsp;&nbsp;
            <button class="btn btn-primary btn-sm" @click.prevent="generateReading(props.rowData)">Generate Reading in PDF</button>
          </center>
        </template>

      </vuetable>
    </div>
    

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import commaNumber from "comma-number";
  import jsPDF from 'jspdf';
  import {RobotoFont} from '@/assets/fonts/RobotoMono-VariableFont_wght-normal'
  import axios from "axios";
  import {
    mapState
  } from 'vuex'

  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';

  const { isArray } = require("axios/lib/utils");

  var component_x;

  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: {
        type: String
      },
      accessRights: {
        type: Array,
        required: false
      }

    },
    components: {
      Vuetable,
      VuetablePagination
    },
    computed: {
      ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'serverType']),
      serviceChargeSummary() {
        if (
          !this.xread_data ||
          !this.xread_data.chargeTypeList ||
          !this.xread_data.chargeSummary
        ) {
          return []
        }

        const chargeTypes = this.xread_data.chargeTypeList
        const summary = this.xread_data.chargeSummary

        const rows = []

        chargeTypes.forEach(type => {
          const code = type.code

          const baseAmount = parseFloat(summary[code + '_base'] || 0)
          const taxAmount = parseFloat(summary[code] || 0)

          if (baseAmount > 0) {
            rows.push({
              label: 'BASE AMOUNT',
              amount: baseAmount
            })
          }

          if (taxAmount > 0) {
            rows.push({
              label: type.name,
              amount: taxAmount
            })
          }
        })

        return rows
      },
      reservationOtherCollectionsSummary() {
        if (
          !this.xread_data ||
          !this.xread_data.reservation ||
          !this.xread_data.reservation.other_collections
        ) {
          return []
        }

        const collections = this.xread_data.reservation.other_collections

        return Object.keys(collections)
          .map(key => {
            const rows = collections[key]

            if (!Array.isArray(rows) || rows.length === 0) return null

            const total = rows.reduce((sum, row) => {
              return sum + parseFloat(row.amount || 0)
            }, 0)

            return total > 0
              ? {
                name: this.formatCollectionName(key),
                amount: total,
                count: rows.length
              }
              : null
          })
          .filter(Boolean)
      },
      reservationPaymentSummary() {
        if (!this.xread_data || !this.xread_data.reservation) return []

        const reservation = this.xread_data.reservation
        const paymentTypesList = reservation.paymentTypesList || []
        const paymentBreakdown = reservation.paymentBreakdown || {}

        return paymentTypesList
          .map(type => {
            const rows = paymentBreakdown[type.code]
            if (!rows || !Array.isArray(rows) || rows.length === 0) return null
            const total = rows.reduce((sum, row) => {
              return sum + parseFloat(row.amount || 0)
            }, 0)
            return total > 0
              ? { name: type.name, amount: total, count: rows.length }
              : null
          })
          .filter(Boolean)
      }
    },
    data() {
      return {
        z_read_type: 5.0, // default
        accumulatedSalesDisplayType: 'gross', //default
        tableType: "x_reading",
        xread_data: null,
        drawerVisible: false,
        filterStatus: "",
        profileAction: "",
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        visible: false,
        availableFields: [],
        apiURL: "",
        export_fields: ["site", "cashier", "terminal", "business_date", "time_generated", "gross_amount", "net_amount", "trans_count", "si_count"],
        fields: [{name: "site_name", title: "Site"}, 
                  {name: "cashier_name", title: "Cashier"},
                  {name: "terminal_name", title: "Terminal"}, 
                  {name: "business_date", title: "Business Date"},
                  {name: "pos_created_at", title: "Time Generated"},
                  {name: "gross_amount", title: "Gross Amount"},
                  {name: "net_amount", title: "Net Amount"},
                  {name: "trans_count", title: "Trans Count"},
                  {name: "si_count", title: "SI Count"},
                  '__slot:actions'],
        sortOrder: [{
          field: "business_date",
          direction: "desc"
        }],
        httpOptions: {
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
          }
        },
        css: {
          table: {
            tableClass: 'table table-sm table-striped table-bordered table-hovered',
            loadingClass: 'loading'
          },
          pagination: {
            infoClass: 'pull-right',
            wrapperClass: 'vuetable-pagination pull-right',
            activeClass: 'btn-primary btn-sm',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          }
        }
      }
    },
    watch: {
      currentApiURL: function () {
        this.apiURL = this.currentApiURL
        // console.log(this.currentApiURL.includes("x_readings"))
      },
      parameters: function () {
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters
        this.$refs.vuetable.selectedTo = []		
        this.checkedItems = []
      }
    },
    methods: {
      async showActionDrawer(action) {
        this.profileAction = action;
        // this.drawerVisible = true;
        this.download();
      },
      download() {
        var payload = {};
        var additional_parameters = "";
        let file_type = 'csv'
        
        additional_parameters = this.parameters;
        var baseUrl = this.endPoint + 'x_readings' + `/download?file_type=${file_type}`;
        var exportFields = this.export_fields;

        payload["fields"] = exportFields;
        additional_parameters = additional_parameters.replace("?", "&");
        axios({
          url: baseUrl + additional_parameters,
          method: "POST",
          responseType: "blob", // important
          headers: {
            Authorization: "Bearer " + secureStorage.getItem("accessToken"),
            "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
          },
          data: payload,
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `x_reading_list.${file_type}`);
          document.body.appendChild(link);
          link.click();
          this.onClose();
          this.filterStatus = null;
          this.successMessage = "Download successful";
        });
      },

      formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      showDetails(zread){  
          this.drawerVisible = true;
          // this.xread_data = JSON.parse(zread);
          this.xread_data = zread;
          this.x_read_type = this.xread_data && this.xread_data.version ? (this.xread_data.version == 5.1 ? 5.1 : 5.0) : 5.0
          this.accumulatedSalesDisplayType = this.xread_data && this.xread_data.config ? (this.xread_data.config.accumulatedSalesDisplayType == 0 ? 'net' : 'gross') : 'gross';
          this.sort('transaction_types', this.xread_data.transactionTypeList)
      },
      onClose(){
          this.drawerVisible = false
      },
      refreshPage() {
        this.onClose()
        this.$refs.vuetable.refresh()
        this.successMessage = "Successful Operation"
        this.errorMessage = null
      },
      removeMessage(type) {
        if (type == 'error')
          this.errorMessage = null
        else
          this.successMessage = null
      },
      async onPaginationData(paginationData) {
        // await axios({
        //     method: 'PUT',
        //     url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
        //     headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
        // })
        this.$refs.pagination.setPaginationData(paginationData);
      },
      async onLoadError(error) {
        // request for new token or reauthenticate
        if (error.response.status == 401) {
          var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
          if (auth_response["status"] == "Ok") {
            this.$router.go();
          } else {
            alert("Cannot get access token. Please login again.")
            this.$router.push("/")
          }
        } else {
          if(error.response.data.error == "Session expired"){
              alert("Session is already expired. Please login again.")
              document.getElementById("logoutButton").click()
          }
        }
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      },
      sort(type, data){
        data.sort(function (a, b) {
          if (type == 'transaction_types') {
            return a.tranTypeName.localeCompare(b.tranTypeName);
          } else {
            return a.name.localeCompare(b.name);
          }
        });
      },
      // based on x reading printout in POS
      async generateReading(data) {
        let dataToPrint = data.reading_details, terminal_id = data.terminal_id

        var getSettings = await HTTPRequest.getRequest(this.endPoint + `terminals/authenticate?terminal_id=${terminal_id}`, null)
        var terminalSettings = getSettings.pos_terminal_settings
        var terminalData = await HTTPRequest.getRequest(this.endPoint + `terminals/${terminal_id}`, null)
        var site = await HTTPRequest.getRequest(this.endPoint + `sites/${terminalData.site_id}`, null)

        let maxCharacterLength = terminalSettings.some(setting => setting.code == "printerMaxCharacterLength") ? parseInt(terminalSettings.find(setting => setting.code == "printerMaxCharacterLength").value) : 42, 
          defaultCharacterLength = 42,
          amountAndCountSpace = maxCharacterLength - defaultCharacterLength,
          countLessSpace = 0,
          amountLessSpace = 0,
          spacesToSplit = 0;

        if (amountAndCountSpace != 0) {
          spacesToSplit = amountAndCountSpace / 2;
          if (spacesToSplit.toString().includes(".")) {
            // if may remainder priority to add space to amount than count text
            countLessSpace = parseInt(spacesToSplit.toString().split(".")[0]);
            amountLessSpace = parseInt(spacesToSplit.toString().split(".")[0]);
            if (amountAndCountSpace > 0) countLessSpace++;
            else amountLessSpace--;
          } else {
            countLessSpace = spacesToSplit;
            amountLessSpace = spacesToSplit;
          }
        }

        const qty = "QTY";
        const net = "NET";
        const paddedQty = qty.padEnd(5);
        const paddedNet = net.padEnd(12);

        let textToAppend = "";

        function addSpace(count) {
          try {
            return " ".repeat(count);
          } catch (err) {
            return " ".repeat(0);
          }
        }

        function alignToReceipt(align, textToAlign) {
          switch (align) {
            case "ct":
              return `${addSpace(
                (maxCharacterLength - textToAlign.length) / 2
              )}${textToAlign}`;
            case "rt":
              return `${addSpace(
                maxCharacterLength - textToAlign.length
              )}${textToAlign}`;
            default:
              return textToAlign;
          }
        }

        function formatReceiptNumber (data = {}) {
          let transactionNumberLength = 10,
            transactionNumber = parseInt(data.transactionNumber) || 0;

          return `${"0".repeat(
            transactionNumberLength - transactionNumber.toString().length
          )}${transactionNumber}`;
        }

        function formatNumberToCurrency(number) {
          let stringNumber = commaNumber(number);
          if (!stringNumber.includes(".")) return `${stringNumber}.00`;
          else if (stringNumber.split(".")[1].length == 1) return `${stringNumber}0`;
          else return stringNumber;
        }

        function roundNumber(number, nearestDecimal) {
          try {
            return parseFloat((parseFloat(number) + 0.0000001).toFixed(nearestDecimal));
          } catch (error) {
            console.log("error in rounding item", error);
          }
        }

        function parseToFinalFormat(number = 0) {
          if (number == null) number = 0;
          return formatNumberToCurrency(roundNumber(parseFloat(number) + 0.0000001, 2)); // Add 0.0000001 to round up >= 5.
        }

        function numberWithCommas(args) {
          return args ? args.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";
        }

        function formatToCorrectText(textToFormat = "") {
          return textToFormat
            .replace("NaN", "")
            .replace("undefined", "")
            .replace("null", "")
            .replace(/\\n/g, "\n")
            .replace(/\ñ/g, "n")
            .replace(/\Ñ/g, "N");
        }

        const doc = new jsPDF({
          orientation: 'p',
          unit: 'in',
          format: 'letter'
        });
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const xMargin = 2.25; // left and right margin
        const yMargin = 1; // top and botton margin including the header/footer. In px since that's what hte jsPDF is set to use
        const lineHeight = 0.15 // doc.getLineHeight(); // default space between lines
        const needNewPageAfterThisYPos = pageHeight - yMargin - 0.25

        doc.addFileToVFS('RobotoMono-VariableFont_wght.ttf', RobotoFont);
        doc.addFont('RobotoMono-VariableFont_wght.ttf', 'RobotoMono-VariableFont_wght', 'normal');
        doc.setFont('RobotoMono-VariableFont_wght', 'normal')
        doc.setFontSize(10);

        let nonVatSetting = terminalSettings.some(setting => setting.code == "enableSetInvoiceHeaderTinAsNonVat") ? terminalSettings.find(setting => setting.code == "enableSetInvoiceHeaderTinAsNonVat").value : false

        let receiptHeader = `${terminalSettings.find(setting => setting.code == "siteName").value ?  formatToCorrectText(terminalSettings.find(setting => setting.code == "siteName").value)
            : "IRIPPLE STORE"
          }\n` +
          `Operated By: ${site.company_name || "IRIPPLE INC."}\n` +
          `${terminalSettings.find(setting => setting.code == "siteAddress").value
            ? formatToCorrectText(terminalSettings.find(setting => setting.code == "siteAddress").value)
            : "Ortigas Center, Pasig City"
          }\n` +
          `${nonVatSetting
            ? "NON VAT"
            : "VAT"
          } REG TIN: ${terminalSettings.find(setting => setting.code == "vatRegistrationTIN").value || "123-456-789-00000"
          }\n` +
          `SN: ${terminalData["serial_no"] || ""}\n` +
          `MIN: ${terminalData["machine_no"] || ""}\n` +
          `Permit No. ${terminalSettings.find(setting => setting.code == "ptusmNumber").value || ""}`

        let {
          xReadingCounter,
          terminal,
          printedBy,
          businessDay,
          printedDate,
          grossSales,
          deductions,
          adjustmentsOnVat,
          otherIncome,
          amountInDrawer,
          paymentSummary,
          netSales,
          netVatAmount,
          totalQuantity,
          paymentTypesList,
          transactionTypeList,
          firstTransactionId,
          lastTransactionId,
          totalTransactionCount,
          reservation
        } = dataToPrint;

        let grossSalesText = parseToFinalFormat(grossSales.total),
            grossVatableSalesText = parseToFinalFormat(grossSales.vatable),
            grossVatAmountText = parseToFinalFormat(grossSales.vatAmount),
            grossVatExemptSalesText = parseToFinalFormat(grossSales.vatExempt),
            grossZeroRatedSalesText = parseToFinalFormat(grossSales.zeroRated),
            totalReturnsDiscountText = `${parseToFinalFormat(
              deductions.returns
            )}`,
            totalVoidsDiscountText = `${parseToFinalFormat(deductions.void)}`,
            totalSpecialVatExemptDiscountText = `${parseToFinalFormat(
              deductions.specialVatExemptDiscount
            )}`,
            totalSpecialVatableDiscountText = `${parseToFinalFormat(
              deductions.specialVatableDiscount
            )}`,
            totalRegularDiscountText = `${parseToFinalFormat(
              deductions.regular
            )}`,
            totalManualDiscountText = `${parseToFinalFormat(
              deductions.manual
            )}`,
            totalDiscountText = `${parseToFinalFormat(deductions.total)}`,
            vatAdjustmentRegularText = `${parseToFinalFormat(
              adjustmentsOnVat.regular
            )}`,
            vatAdjustmentSpecialVatableText = `${parseToFinalFormat(
              adjustmentsOnVat.specialVatableDiscount
            )}`,
            vatAdjustmentSpecialVatExemptText = `${parseToFinalFormat(
              adjustmentsOnVat.specialVatExemptDiscount
            )}`,
            vatAdjustmentReturnsText = `${parseToFinalFormat(
              adjustmentsOnVat.returns
            )}`,
            vatAdjustmentVoidText = `${parseToFinalFormat(
              adjustmentsOnVat.void
            )}`,
            vatAdjustmentManualText = `${parseToFinalFormat(
              adjustmentsOnVat.manual
            )}`,
            totalVatAdjustmentText = `${parseToFinalFormat(
              adjustmentsOnVat.total
            )}`,
            totalQuantityText = `${parseToFinalFormat(totalQuantity)}`,
            totalSalesCountText = numberWithCommas(grossSales.count),
            totalReturnsCountText = numberWithCommas(deductions.returnsCount),
            totalVoidsCountText = numberWithCommas(deductions.voidCount),
            totalManualCountText = numberWithCommas(deductions.manualCount),
            netSalesText = parseToFinalFormat(netSales),
            netVatAmountText = parseToFinalFormat(netVatAmount),
            excessGCText = parseToFinalFormat(otherIncome.excessGC),
            excessRSText = parseToFinalFormat(otherIncome.excessRS),
            totalOtherIncomeText = parseToFinalFormat(otherIncome.total),
            depositText = parseToFinalFormat(amountInDrawer.deposit),
            paymentsText = parseToFinalFormat(amountInDrawer.payments),
            withdrawalText = `(${parseToFinalFormat(
              amountInDrawer.withdrawal
            )})`,
            amountInDrawerText = parseToFinalFormat(amountInDrawer.total),
            totalPaymentsText = parseToFinalFormat(paymentSummary.total),
            rsExcessText = parseToFinalFormat(paymentSummary.rsExcess),
            gcExcessText = parseToFinalFormat(paymentSummary.gcExcess),
            checkChangeText = parseToFinalFormat(paymentSummary.checkChange),
            firstTransactionIdText = firstTransactionId.toString(),
            lastTransactionIdText = lastTransactionId.toString(),
            transactionCountText = totalTransactionCount.toString(),
            reservationCollections = parseToFinalFormat(
              reservation ? reservation.collections.paymentSummary.total :0
            ),
            reservationPaymentSummary = reservation ? reservation.collections.paymentSummary : {},
            reservationPaymentList =reservation ? reservation.paymentTypesList : [],
            reservationPaymentBreakdown = reservation ? reservation.paymentBreakdown : null,
            reservationCancellations = parseToFinalFormat(
              reservation ? reservation.cancellations.paymentSummary.total : 0
            ),
            beginningAr = formatReceiptNumber({
              // type: RECEIPT_TYPES.ACKNOWLEDGEMENT,
              transactionNumber: reservation ? reservation.beginningAr : 0,
            }),
            endingAr = formatReceiptNumber({
              // type: RECEIPT_TYPES.ACKNOWLEDGEMENT,
              transactionNumber: reservation ? reservation.endingAr : 0,
            }),
            arCount = `${reservation ? reservation.arCount : 0}`,
            arResetCount = `${reservation ? reservation.arResetCount : 0}`;

        //Header
        receiptHeader.split("\n").forEach((line) => {
          textToAppend += `\n${alignToReceipt("ct", line)}`;
        });
        textToAppend +=
          `\n${alignToReceipt("ct", "X-READING REPORT")}\n`;

        // TERMINAL INFO
        textToAppend +=
          `\nX Reading # : ${xReadingCounter}` +
          `\nTerminal    : ${terminalData.name}` +
          `\nCashier     : ${dataToPrint.cashierName}` +
          `\nPrinted by  : ${printedBy}` +
          `\nBusiness Day: ${businessDay}` +
          `\nPrinted Date: ${printedDate}\n`;

        // GROSS SALES
        textToAppend +=
          `\nGROSS SALES ${addSpace(
            maxCharacterLength -
            13 -
            15 -
            totalSalesCountText.length -
            countLessSpace // For more than or less than the default length spacing
          )}${totalSalesCountText}${addSpace(
            maxCharacterLength - 27 - grossSalesText.length - amountLessSpace // For more than or less than the default length spacing
          )}${grossSalesText} ` +
          `\n  VATABLE SALES ${addSpace(
            maxCharacterLength - 17 - grossVatableSalesText.length
          )}${grossVatableSalesText} ` +
          `\n  VAT AMOUNT ${addSpace(
            maxCharacterLength - 14 - grossVatAmountText.length
          )}${grossVatAmountText} ` +
          `\n  VAT-EXEMPT SALES ${addSpace(
            maxCharacterLength - 20 - grossVatExemptSalesText.length
          )}${grossVatExemptSalesText} ` +
          `\n  ZERO-RATED SALES ${addSpace(
            maxCharacterLength - 20 - grossZeroRatedSalesText.length
          )}${grossZeroRatedSalesText} `;

        textToAppend += `\n${"-".repeat(maxCharacterLength)}`;

        // DEDUCTIONS
        textToAppend +=
          `\nDEDUCTIONS ${addSpace(
            maxCharacterLength - 12 - totalDiscountText.length
          )}${totalDiscountText} ` +
          `\n  REG DISC ${addSpace(
            maxCharacterLength - 12 - totalRegularDiscountText.length
          )}${totalRegularDiscountText} ` +
          `\n  SP 5% DISC ${addSpace(
            maxCharacterLength - 14 - totalSpecialVatableDiscountText.length
          )}${totalSpecialVatableDiscountText} ` +
          `\n  SP 20% DISC ${addSpace(
            maxCharacterLength - 15 - totalSpecialVatExemptDiscountText.length
          )}${totalSpecialVatExemptDiscountText} ` +
          `\n  RETURNS ${addSpace(
            maxCharacterLength -
            11 -
            15 -
            totalReturnsCountText.length -
            countLessSpace // For more than or less than the default length spacing
          )}${totalReturnsCountText}${addSpace(
            maxCharacterLength -
            27 -
            totalReturnsDiscountText.length -
            amountLessSpace // For more than or less than the default length spacing
          )}${totalReturnsDiscountText} ` +
          `\n  VOID ${addSpace(
            maxCharacterLength -
            8 -
            15 -
            totalVoidsCountText.length -
            countLessSpace // For more than or less than the default length spacing
          )}${totalVoidsCountText}${addSpace(
            maxCharacterLength -
            27 -
            totalVoidsDiscountText.length -
            amountLessSpace // For more than or less than the default length spacing
          )}${totalVoidsDiscountText} ` +
          `\n  MANUAL ${addSpace(
            maxCharacterLength -
            10 -
            15 -
            totalManualCountText.length -
            countLessSpace // For more than or less than the default length spacing
          )}${totalManualCountText}${addSpace(
            maxCharacterLength -
            27 -
            totalManualDiscountText.length -
            amountLessSpace // For more than or less than the default length spacing
          )}${totalManualDiscountText} `;

        textToAppend += `\n${"-".repeat(maxCharacterLength)}`;

        // VAT ADJUSTMENTS
        textToAppend +=
          `\nVAT ADJUSTMENTS ${addSpace(
            maxCharacterLength - 17 - totalVatAdjustmentText.length
          )}${totalVatAdjustmentText} ` +
          `\n  REG DISC ${addSpace(
            maxCharacterLength - 12 - vatAdjustmentRegularText.length
          )}${vatAdjustmentRegularText} ` +
          `\n  SP 5% DISC ${addSpace(
            maxCharacterLength - 14 - vatAdjustmentSpecialVatableText.length
          )}${vatAdjustmentSpecialVatableText} ` +
          `\n  SP 20% DISC ${addSpace(
            maxCharacterLength - 15 - vatAdjustmentSpecialVatExemptText.length
          )}${vatAdjustmentSpecialVatExemptText} ` +
          `\n  RETURNS ${addSpace(
            maxCharacterLength - 11 - vatAdjustmentReturnsText.length
          )}${vatAdjustmentReturnsText} ` +
          `\n  VOID ${addSpace(
            maxCharacterLength - 8 - vatAdjustmentVoidText.length
          )}${vatAdjustmentVoidText} ` +
          `\n  MANUAL ${addSpace(
            maxCharacterLength - 10 - vatAdjustmentManualText.length
          )}${vatAdjustmentManualText} `;

        textToAppend += `\n${"-".repeat(maxCharacterLength)}`;

        // NET SALES , NET VAT AMOUNT
        textToAppend +=
          `\nNET SALES ${addSpace(
            maxCharacterLength - 11 - netSalesText.length
          )}${netSalesText} ` +
          `\nNET VAT AMOUNT ${addSpace(
            maxCharacterLength - 16 - netVatAmountText.length
          )}${netVatAmountText} `;

        // TOTAL QUANTITY
        textToAppend += `\nTOTAL QUANTITY ${addSpace(
          maxCharacterLength - 16 - totalQuantityText.length
        )}${totalQuantityText} `;

        // OTHER INCOME
        textToAppend +=
          `\nOTHER INCOME ${addSpace(
            maxCharacterLength - 14 - totalOtherIncomeText.length
          )}${totalOtherIncomeText} ` +
          `\n  EXCESS GC ${addSpace(
            maxCharacterLength - 13 - excessGCText.length
          )}${excessGCText} ` +
          `\n  EXCESS RS ${addSpace(
            maxCharacterLength - 13 - excessRSText.length
          )}${excessRSText} `;

        let enablePrintAmountInDrawer = terminalSettings.some(setting => setting.code === 'enablePrintAmountInDrawer') ? terminalSettings.find(setting => setting.code === 'enablePrintAmountInDrawer').value : true;

        let excludeUnfulfilledReservationPayment = terminalSettings.some(setting => setting.code === 'excludeUnfulfilledReservationPayment') ? terminalSettings.find(setting => setting.code === 'excludeUnfulfilledReservationPayment').value : false

        // DRAWER INFORMATION
        textToAppend += enablePrintAmountInDrawer
          ? `\nAMOUNT IN DRAWER ${addSpace(
            maxCharacterLength - 18 - amountInDrawerText.length
          )}${amountInDrawerText} ` +
          `\n+ DEPOSIT ${addSpace(
            maxCharacterLength - 11 - depositText.length
          )}${depositText} ` +
          `\n+ PAYMENTS ${addSpace(
            maxCharacterLength - 12 - paymentsText.length
          )}${paymentsText} ` +
          `\n- WITHDRAWAL ${addSpace(
            maxCharacterLength - 14 - withdrawalText.length
          )}${withdrawalText}` : "";
          enablePrintAmountInDrawer &&
          excludeUnfulfilledReservationPayment ? "" :
          `\n+ RESV COLLECTION ${addSpace(
            maxCharacterLength - 19 - reservationCollections.length
          )}${reservationCollections}` +
          `\n- RESV COLLECTION ${addSpace(
            maxCharacterLength - 19 - reservationCancellations.length
          )}${reservationCancellations}`;

        let enableZeroPaymentsInZReading = terminalSettings.some(setting => setting.code === 'enableZeroPaymentsInZReading') ? terminalSettings.find(setting => setting.code === 'enableZeroPaymentsInZReading').value : false

        // PAYMENT SUMMARY
        textToAppend += `\nPAYMENT SUMMARY ${addSpace(
          maxCharacterLength - 17 - totalPaymentsText.length
        )}${totalPaymentsText} `;

        // Loop to every payment
        paymentTypesList.forEach((pt) => {
          if (
            (enableZeroPaymentsInZReading &&
              paymentSummary[pt.code] == 0) ||
            paymentSummary[pt.code] > 0
          ) {
            let paymentCountText =
              numberWithCommas(paymentSummary[pt.code + "Count"]) || 0;
            let paymentAmountText = parseToFinalFormat(paymentSummary[pt.code]);
            textToAppend += `\n  ${pt.name} ${maxCharacterLength -
              (pt.name.length + 4) - // The +3 = is the spaces before the payment name and the space at the end of this line
              15 -
              paymentCountText.length -
              countLessSpace < // For more than or less than the default length spacing
              0
              ? `\n` +
              addSpace(
                maxCharacterLength -
                15 -
                paymentCountText.length -
                countLessSpace -
                1 // The space before the countText
              ) // New line and add space for the payment types exceeding character length allocated for payment type name
              : ""
              }${addSpace(
                maxCharacterLength -
                (pt.name.length + 4) - // The +3 = is the spaces before the payment name and the space at the end of this line
                15 -
                paymentCountText.length -
                countLessSpace // For more than or less than the default length spacing
              )}${paymentCountText}${addSpace(
                maxCharacterLength -
                27 -
                paymentAmountText.length -
                amountLessSpace // For more than or less than the default length spacing
              )}${paymentAmountText} `;

              switch (pt.code) {
                case /*PAYMENTS.CHECK*/ "CHECK": {
                  textToAppend += `\n  Change for Check ${addSpace(
                    maxCharacterLength - 21 - checkChangeText.length
                  )}(${checkChangeText})`;
                  break;
                }
                case /*PAYMENTS.CREDIT_MEMO*/ "CMEMO": {
                  textToAppend += `\n      RS EXCESS ${addSpace(
                    maxCharacterLength - 17 - rsExcessText.length
                  )}${rsExcessText} `;
                  break;
                }
                case /*PAYMENTS.OFFLINE_GC*/ "GC": {
                  textToAppend += `\n      GC EXCESS ${addSpace(
                    maxCharacterLength - 17 - gcExcessText.length
                  )}${gcExcessText} `;
                  break;
                }
              }
            }
        });

        try {
                      // TRANSACTION TYPE SUMMARY
          textToAppend += `\nTRANSACTION TYPE SUMMARY`;
           //sort based on tranType name values
          transactionTypeList.sort((a, b) => a.tranTypeName.localeCompare(b.tranTypeName));
          transactionTypeList.forEach((tranType) => {
            let tranTypeNameText = tranType.tranTypeName.toString();
            let tranTypeCountText = tranType.count.toString();
            let tranTypeTotalText = parseToFinalFormat(tranType.total.toString());

            // Split the product name into chunks of 18 characters each and pad them individually
            const prodNameChunks = tranTypeNameText.match(
              new RegExp(
                `.{1,${maxCharacterLength -
                tranTypeCountText.length -
                tranTypeTotalText.length
                }}`,
                "g"
              )
            ) || [tranTypeNameText];
            const paddedProdName = prodNameChunks.map((chunk) =>
              chunk.padEnd(18)
            );

            // Combine the columns into a single string
            let line = `${paddedProdName[0]}${tranTypeCountText.padEnd(
              8
            )}${tranTypeTotalText.padEnd(10)}`;
            textToAppend += `\n  ${line}`;
            // Add any additional chunks of the product name as new lines
            for (let i = 1; i < prodNameChunks.length; i++) {
              if (i == 0) {
                textToAppend += `\n${prodNameChunks[i].padEnd(
                  maxCharacterLength - paddedQty.length - paddedNet.length
                )}${quantity.padEnd(8)}${alignToReceipt("rt", net.padEnd(10))}`;
              } else {
                textToAppend += `\n${prodNameChunks[i].padEnd(
                  maxCharacterLength - paddedQty.length - paddedNet.length
                )}`;
              }
            }
          });
        } catch (error) {
          logError("error in mapping payment type summary" , error);
          console.log(error);
        }

        //VALUE ADDED SERVICES
        if (data.isVASEnabled) {
          let totalTopUpAmountText = parseToFinalFormat(
            data.totalTopUpAmount
          ),
          totalBillPaymentsAmountText = parseToFinalFormat(
            data.totalBillPaymentsAmount
          ),
          totalConvFeeAmountText = parseToFinalFormat(
            data.totalConvFeeAmount
          ),
          totalECCashAmountText = parseToFinalFormat(
            data.totalECCashAmount
          ),
          totalTextAPinAmountText = parseToFinalFormat(
            data.totalTextAPinAmount
          ),
          totalARTransactionAmountText = parseToFinalFormat(
            data.totalARTransactionAmount
          ),
          totalARCashAmountText = parseToFinalFormat(
            data.totalARCashAmount
          ),
          totalAREmployeeChargeAmountText = parseToFinalFormat(
            data.totalAREmployeeChargeAmount
          );
          textToAppend +=
            `\n${"*".repeat(maxCharacterLength)}` +
            `\n${alignToReceipt("ct", "VALUE ADDED SERVICES")}` +
            `\nTOP UP ${addSpace(
              maxCharacterLength - 7 - totalTopUpAmountText.length
            )}${totalTopUpAmountText}` +
            `\nBILLS PAYMENTS ${addSpace(
              maxCharacterLength - 15 - totalBillPaymentsAmountText.length
            )}${totalBillPaymentsAmountText}` +
            `\n      CONV FEE ${addSpace(
              maxCharacterLength - 15 - totalConvFeeAmountText.length
            )}${totalConvFeeAmountText}` +
            `\nECCASH ${addSpace(
              maxCharacterLength - 7 - totalECCashAmountText.length
            )}${totalECCashAmountText}` +
            `\nTEXT-A-PIN ${addSpace(
              maxCharacterLength - 11 - totalTextAPinAmountText.length
            )}${totalTextAPinAmountText}` +
            `\n${alignToReceipt("rt", "-".repeat(13))}` +
            `\nTOTAL TRANSACTION AMOUNT ${addSpace(
              maxCharacterLength - 25 - totalARTransactionAmountText.length
            )}${totalARTransactionAmountText}` +
            `\n\nPAYMENT SUMMARY` +
            `\n      CASH ${addSpace(
              maxCharacterLength - 11 - totalARCashAmountText.length
            )}${totalARCashAmountText}` +
            `\n      EMPLOYEE CHARGE ${addSpace(
              maxCharacterLength - 22 - totalAREmployeeChargeAmountText.length
            )}${totalAREmployeeChargeAmountText}`;
        }

        let otherManualCollections =  
            reservation ?
            reservation.other_collections : {};
        let otherCollectionAmount = 0;
        console.log("other collections" , otherManualCollections)
        if(otherManualCollections){
          otherCollectionAmount = otherManualCollections.total;      
        }
        
        console.log({otherCollectionAmount , reservationCollections})
        let otherCollectionAmountString = `${parseToFinalFormat(otherCollectionAmount)}`
        let finalCollection = parseFloat(reservation ? reservation.collections.paymentSummary.total :0) + parseFloat(otherCollectionAmount)
        
            finalCollection = `${parseToFinalFormat(finalCollection)}`;
            textToAppend +=
              `\n${"*".repeat(maxCharacterLength)}\n` +
              `\n${alignToReceipt("ct", "COLLECTIONS")}` +
              `\nAR RESET COUNT  :${addSpace(
                maxCharacterLength - 18 - arResetCount.length
              )}${arResetCount}` +
              `\nBEGINNING AR    :${addSpace(
                maxCharacterLength - 18 - beginningAr.length
              )}${beginningAr}` +
              `\nENDING AR       :${addSpace(
                maxCharacterLength - 18 - endingAr.length
              )}${endingAr}` +
              `\nAR COUNT        :${addSpace(
                maxCharacterLength - 18 - arCount.length
              )}${arCount}\n` +
              `\nRESERVATION DP${addSpace(
                maxCharacterLength - 15 - reservationCollections.length
              )}${reservationCollections}` +
              `\nOTHER COLLECTIONS:${addSpace(
                maxCharacterLength - 19 - otherCollectionAmountString.length
              )}${otherCollectionAmountString}` +

              // Add Gift Cert Selling and Online Payment Amounts here
              `\n${alignToReceipt("rt", "-".repeat(13))}` +
              `\nTOTAL         :${addSpace(
                maxCharacterLength - 16 - finalCollection.length
              )}${finalCollection}\n`;
            
              finalCollection = `${parseToFinalFormat(finalCollection)}`
          textToAppend +=
            `\n${"*".repeat(maxCharacterLength)}\n` +
            `\n${alignToReceipt("ct", "COLLECTIONS")}` +
            `\nAR RESET COUNT  :${addSpace(
              maxCharacterLength - 18 - arResetCount.length
            )}${arResetCount}` +
            `\nBEGINNING AR    :${addSpace(
              maxCharacterLength - 18 - beginningAr.length
            )}${beginningAr}` +
            `\nENDING AR       :${addSpace(
              maxCharacterLength - 18 - endingAr.length
            )}${endingAr}` +
            `\nAR COUNT        :${addSpace(
              maxCharacterLength - 18 - arCount.length
            )}${arCount}\n` +
            `\nRESERVATION DP${addSpace(
              maxCharacterLength - 15 - reservationCollections.length
            )}${reservationCollections}` +
            `\nOTHER COLLECTIONS:${addSpace(
              maxCharacterLength - 19 - otherCollectionAmountString.length
            )}${otherCollectionAmountString}` +

            // Add Gift Cert Selling and Online Payment Amounts here
            `\n${alignToReceipt("rt", "-".repeat(13))}` +
            `\nTOTAL         :${addSpace(
              maxCharacterLength - 16 - finalCollection.length
            )}${finalCollection}`;     
            
          let isTitleAppended = false;
          if(reservationPaymentBreakdown){
            for (const [index, [key, Collectiondata]] of Object.entries(reservationPaymentBreakdown).entries()) {
              const count = Collectiondata.length || 0;
              const paymentName = reservationPaymentList.filter(item => item.code === key);
              const paymentTitleString = `${paymentName.length > 0 ? paymentName[0].name : key} (${count})`;
              
              // console.log(`Index: ${index}`, { Collectiondata });
              if(count != 0 && !isTitleAppended){
                textToAppend += `\nPAYMENT SUMMARY\n`
                isTitleAppended = true;
              }
              if (count !== 0) {
                const amount = Collectiondata.reduce((acc, curr) => {
                  return acc + parseFloat(curr.amount);
                }, 0);
                
                const amountString = `${parseToFinalFormat(amount)}`;
                textToAppend += `${addSpace(1)}${paymentTitleString}${addSpace(maxCharacterLength - (paymentTitleString.length + (amountString.length+1)))}${amountString}\n`;
              }
            }
          }

          let isTitleAppend = false;
          if(otherManualCollections)
            for (const [index, [key, Collectiondata]] of Object.entries(otherManualCollections).entries()) {
              const count = Collectiondata.length;
              const paymentTitleString = `${key} (${count})`;
              if(count != 0 && !isTitleAppend){
                textToAppend += `\nCOLLECTION SUMMARY\n`
                isTitleAppend = true;
              }
                
              if (count !== 0) {
                console.log("Collectiondata" , Collectiondata);
                if(isArray(Collectiondata)){
                  const amount = Collectiondata.reduce((acc, curr) => {
                    return acc + parseFloat(curr.amount);
                  }, 0);
              
                  const amountString = `${parseToFinalFormat(amount)}`;
                  textToAppend += `${paymentTitleString}${addSpace(maxCharacterLength - (paymentTitleString.length + amountString.length))}${amountString}\n`;
                }
               
              }
            }

            let enableTransactionsCountInXReading = terminalSettings.some(setting => setting.code === "enableTransactionsCountInXReading") ? terminalSettings.find(setting => setting.code === "enableTransactionsCountInXReading").value : false;

            textToAppend += enableTransactionsCountInXReading
            ? `\nFIRST TRANSACTION : ${addSpace(
              maxCharacterLength - 21 - firstTransactionIdText.length
            )}${firstTransactionIdText} ` +
            `\nLAST TRANSACTION  : ${addSpace(
              maxCharacterLength - 21 - lastTransactionIdText.length
            )}${lastTransactionIdText} ` +
            `\nTRANSACTION COUNT : ${addSpace(
              maxCharacterLength - 21 - transactionCountText.length
            )}${transactionCountText} `
            : "";
              
        const wrappedText = doc.splitTextToSize(textToAppend, pageWidth - (2 * xMargin)); // account for both the left and right marigns
        wrappedText.shift() // remove blank line at start
        let yPos;
        wrappedText.forEach((line) => {
          if (yPos > needNewPageAfterThisYPos) {
            doc.addPage();
            yPos = undefined;
          } 
          if (yPos === undefined) {
            yPos = yMargin;
          } else {
            yPos = yPos + lineHeight;
          }
          doc.text(line, xMargin, yPos);
        }); 

        let pageCount = doc.internal.getNumberOfPages();
        let footer_x = 7.5
        let footer_y = 10.25
        for(let i = 1; i <= pageCount; i++) { 
          doc.setPage(i);
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9)
          doc.text(1, footer_y, `${terminalData.name}`)
          doc.text(footer_x, footer_y, `Business Date: ${data.business_date}`, { align: "right" })
          doc.text(1, footer_y + 0.15, `X-Reading #${xReadingCounter}`)
          doc.text(footer_x, footer_y + 0.15, `Page ${i} of ${pageCount}`, { align: "right" });
        }

        // doc.save(`${terminal.name}-zreading-${zReadingCounter}.pdf`);
        window.open(URL.createObjectURL(doc.output("blob")))
      }
    },
    mounted: async function () {
      component_x = this;
      this.apiURL = this.currentApiURL + this.parameters
      if(this.apiURL.includes("x_reading") == true){
          this.tableType = "x_reading"
      }
      console.log(this.$refs.vuetable)
      this.paymentTypes = await HTTPRequest.getRequest(this.endPoint + 'payment_types/get_valid_payment_types', null)
      this.sort('payment_types', this.paymentTypes)
      this.$refs.vuetable.normalizeFields()
      this.$refs.vuetable.refresh()
    }
  }
</script>

<style>
</style>